/** Casca, entrada (T-01), início (T-03), busca (T-04) e ajuda (T-43). */
const en = {
  'app.navLabel': 'Main menu',
  'nav.home': 'Home',
  'nav.admin': 'Administration',
  'nav.users': 'Users and profiles',
  'nav.integrations': 'Integrations Center',
  'nav.audit': 'Audit trail',
  'nav.settings': 'Company settings',
  'ws.label': 'Spaces',
  'ws.home': 'Home',
  'ws.assets': 'Assets',
  'ws.discovery': 'Discovery',
  'ws.maps': 'Maps',
  'ws.monitor': 'Monitor',
  'ws.security': 'Security',
  'ws.governance': 'Governance',
  'ws.delivery': 'Delivery',
  'ws.integrations': 'Integrations',
  'ws.admin': 'Admin',
  'ws.help': 'Help',
  'ws.more': 'More',
  'ws.collapse': 'Collapse menu',
  'ws.expand': 'Expand menu',
  'ws.pin': 'Keep menu open',
  'map.fullscreen': 'Full screen',
  'map.newTab': 'Open in new tab',
  'map.exportPng': 'Image (PNG)',
  'map.exportSvg': 'Image (SVG)',
  'map.exportHint': 'Download the whole map as an image, at full size, with the title and date',
  'map.exportFailed': 'The image could not be generated; try SVG.',
  'map.close': 'Close full screen',
  'nav.helpGroup': 'Help',
  'nav.help': 'Help center and manual',
  'top.home': '{product} — go to Home',
  'top.search': 'Search asset, person, screen or run a command',
  'top.searchLabel': 'Open global search (Ctrl+K)',
  'foot.shortcuts': 'Shortcuts: Ctrl + K global search · Esc closes dialogs',

  'menu.user': 'User menu',
  'menu.activeProfile': 'Active profile',
  'menu.switchProfile': 'Switch active profile',
  'menu.switchedTo': 'Active profile: {name}. Permissions changed right away.',
  'menu.switchFailed': 'The profile could not be switched. Try again.',
  'menu.theme': 'Theme: {name} (change)',
  'menu.install': 'Install Hive as an app',
  'menu.signOut': 'Sign out',
  'menu.signOutTitle': 'Sign out of Hive?',
  'menu.signOutText': 'Data kept on this device (drafts being filled in) is erased when you sign out.',

  'boot.noTenant.title': 'Open your company address',
  'boot.noTenant.text': 'Each company has its own address, like aurora.localhost:47173. Use the address your administrator sent you.',
  'boot.notFound.title': 'There is no active company at this address',
  'boot.notFound.text': 'Check the address with your administrator. If the company was suspended, sign-in comes back when it is reactivated.',
  'boot.error.title': 'Hive could not start',
  'boot.error.note': 'If the problem continues, your administrator can check the platform status with the service provider.',

  'signin.title': 'Sign in to {product}',
  'signin.tagline': 'All of IT in one place — no VPN and no code.',
  'signin.bullet1': 'Inventory of workstations, servers, network and cloud',
  'signin.bullet2': 'Alerts evaluated on the agent itself, in seconds',
  'signin.bullet3': 'Everything through assistants, with a preview before saving',
  'signin.sideFoot': 'Your data stays in your company area. Nothing here is shared with other companies.',
  'signin.sso': 'Sign in with your company account (SSO)',
  'signin.saml': 'Sign in with your company account (SAML)',
  'signin.local': 'Sign in with your Hive account',
  'signin.ldap': 'Domain user and password',
  'signin.ldapNote': 'Domain accounts: use your email or user@domain and the domain password; it is checked in Active Directory by the collector, via LDAPS.',
  'signin.or': 'or',
  'signin.localHint': 'Privileged profiles also confirm with the authenticator app code.',
  'signin.methodsHint': 'Only the ways to sign in that your company turned on are shown.',
  'signin.noMethods': 'No sign-in method is on for this company. Ask your administrator.',
  'signin.redirecting': 'Opening the sign-in page…',
  'signin.redirectingHint': 'You come back to the screen you were on as soon as the sign-in is confirmed.',
  'signin.unreachable': 'The sign-in page could not be reached. Check your connection and try again.',
  'signin.callback.what': 'The sign-in could not be completed.',
  'signin.callback.why': 'The sign-in page returned an error, or the link was opened twice.',
  'signin.callback.fix': 'Sign in again.',
  'signin.pwa.title': 'Install Hive as an app',
  'signin.pwa.text': 'Opens in its own window and updates by itself. No app store.',
  'signin.pwa.manual': 'Use the browser menu: “Install app” or “Add to Home Screen”. No app store.',
  'signin.pwa.install': 'Install',
  'signin.pwa.later': 'Not now',
  'signin.pwa.laterToast': 'All right. You can install it later from the user menu.',
  'signin.email': 'Email',
  'signin.password': 'Password',
  'signin.submit': 'Sign in',
  'signin.forgot': 'Forgot your password?',
  'signin.forgotText': 'Type your email. If there is an account, the link to choose a new password arrives in a few minutes (valid for 1 hour).',
  'signin.forgotSend': 'Send link',
  'signin.forgotSent': 'If the email has an account here, the link is on its way. Check the inbox and the spam folder.',
  'signin.back': 'Back',
  'signin.mfa.title': 'Authenticator code',
  'signin.mfa.text': 'Type the 6-digit code shown in your authenticator app.',
  'signin.mfa.code': 'Code',
  'signin.mfa.recoveryHint': 'Lost the phone? Type one of your recovery codes instead.',
  'signin.verify': 'Confirm',
  'signin.enroll.title': 'Register the authenticator app',
  'signin.enroll.text': 'Your profile requires a second factor. Scan the code with Google Authenticator, Microsoft Authenticator or another TOTP app, then type the code it shows.',
  'signin.enroll.manual': 'Cannot scan? Type this key in the app:',
  'signin.enroll.qr': 'QR code to register the authenticator app',
  'signin.recovery.title': 'Keep your recovery codes',
  'signin.recovery.text': 'Each code signs you in once if you lose the phone. Keep them somewhere safe: they are not shown again.',
  'signin.recovery.copy': 'Copy codes',
  'signin.recovery.copied': 'Codes copied.',
  'signin.recovery.done': 'I saved them, continue',
  'signin.invite.title': 'Create your password',
  'signin.invite.text': 'Welcome to {company}. Choose the password for {email}.',
  'signin.reset.title': 'Choose a new password',
  'signin.reset.text': 'New password for {email}. Your other sessions end.',
  'signin.newPassword': 'New password',
  'signin.confirmPassword': 'Repeat the password',
  'signin.passwordRules': 'At least 12 characters, without your email. A short sentence is easy to remember and hard to guess.',
  'signin.mismatch': 'The two passwords are different.',
  'signin.setPassword': 'Save password and sign in',
  'signin.linkChecking': 'Checking the link…',
  'signin.ssoBack': 'Finishing the sign-in with your company account…',
  'menu.security': 'Account security',
  'auth.kc.title': 'Keycloak as a user source',
  'auth.kc.text': 'Accounts can come from a Keycloak realm: Hive imports them every hour and checks the password there, without showing the Keycloak screen. Access comes from the group mappings below; nothing is written to Keycloak.',
  'auth.kc.connect': 'Connect in the Integrations Center',
  'auth.kc.sync': 'Bring now',
  'auth.kc.done': '{created} new account(s) out of {read} read.',
  'auth.kc.counts': 'Read {read} · new {created} · turned off {disabled} · without a mapped group {without}',
  'sec.me.title': 'Account security',
  'sec.me.sub': 'Your password, the authenticator app and where you are signed in.',
  'sec.me.totp': 'Authenticator app',
  'sec.me.on': 'On',
  'sec.me.off': 'Off',
  'sec.me.since': 'since {when}',
  'sec.me.required': 'Your profile requires the authenticator app.',
  'sec.me.codesLeft': '{n} recovery code(s) left.',
  'sec.me.turnOn': 'Register the app',
  'sec.me.newPhone': 'Change phone',
  'sec.me.newCodes': 'New recovery codes',
  'sec.me.turnOff': 'Turn off',
  'sec.me.codePrompt': 'Confirm with the current code of the app',
  'sec.me.totpOff': 'Authenticator turned off.',
  'sec.me.password': 'Password',
  'sec.me.pwSince': 'Set {when}',
  'sec.me.current': 'Current password',
  'sec.me.change': 'Change password',
  'sec.me.pwChanged': 'Password changed. Your other sessions ended.',
  'sec.me.pwElsewhere': 'Your password is managed by the company directory; change it where you usually do.',
  'sec.me.sessions': 'Where you are signed in',
  'sec.me.device': 'Browser',
  'sec.me.started': 'Signed in',
  'sec.me.lastUse': 'Last use',
  'sec.me.endSession': 'End session',
  'sec.me.endSessionText': 'The browser of that session asks for the password again.',
  'users.resetMfa': 'Reset authenticator',
  'users.resetMfaTitle': 'Reset the authenticator of {email}?',
  'users.resetMfaText': 'Their sessions end and, on the next sign-in, they register the app again (for example, after losing the phone).',
  'users.resetMfaDone': 'Authenticator of {email} reset.',

  'home.title': 'Home',
  'home.sub': 'What needs attention today. Click an item to open the list already filtered.',
  'home.inventory.title': 'Inventory and monitoring',
  'home.inventory.note': 'Filled in as the agents send inventory.',
  'home.notYet': 'No data yet',
  'home.card.assetsByType.title': 'Assets in the inventory',
  'home.card.assetsByType.foot': 'By type, from agents and directories.',
  'home.card.agentCoverage.title': 'Agent coverage',
  'home.card.agentCoverage.foot': 'Known computers that send inventory.',
  'home.card.openAlerts.title': 'Open alerts',
  'home.card.openAlerts.foot': 'By severity.',
  'home.card.changes24h.title': 'Changes in the last 24 h',
  'home.card.changes24h.foot': 'Detected by the agent in seconds.',
  'home.card.agentlessMachines.title': 'Machines without an agent',
  'home.card.agentlessMachines.foot': 'In the directory but not sending inventory yet.',
  'home.card.assetsKind.title': '{kind}',
  'home.kind.notebook': 'Notebooks',
  'home.kind.desktop': 'Desktops',
  'home.kind.server': 'Servers',
  'home.kind.vm': 'Virtual machines',
  'home.kind.printer': 'Printers',
  'home.kind.network': 'Network devices',
  'home.kind.smartphone': 'Smartphones',
  'home.kind.cloud': 'Cloud resources',
  'home.card.supportRequestsPending.title': 'Support access requests',
  'home.card.supportRequestsPending.foot': 'From the service provider team, waiting for your decision.',
  'home.card.invitesPending.title': 'Invitations not accepted yet',
  'home.card.invitesPending.foot': 'People invited who have not signed in yet.',
  'home.card.accessRequestsPending.title': 'People waiting for access',
  'home.card.accessRequestsPending.foot': 'Signed in through the identity provider without an invitation.',
  'home.card.rightsizingSavings.title': 'Potential savings per month ({currency})',
  'home.card.rightsizingSavings.foot': 'Turn off idle machines and downsize oversized ones (Rightsizing & savings).',
  'home.card.rightsizingRecommendations.title': 'Machines to resize',
  'home.card.rightsizingRecommendations.foot': 'Idle, oversized or undersized by their real use (Rightsizing & savings).',
  'home.card.integrationsWithProblems.title': 'Integrations with problems',
  'home.card.integrationsWithProblems.foot': 'Connections with an error or needing attention.',
  'home.card.apiTokensExpiring.title': 'Integration tokens expiring',
  'home.card.apiTokensExpiring.foot': 'Expire in the next 15 days.',
  'home.attention.title': 'What needs attention',
  'home.attention.none': 'Nothing for your profile right now.',
  'home.fs.title': 'First steps',
  'home.fs.progress': '{done} of {total} done',
  'home.fs.goal': 'Goal: first inventory in up to 30 min',
  'home.fs.hide': 'Hide checklist',
  'home.fs.show': 'Show first steps',
  'home.fs.hiddenToast': 'Checklist hidden. It remembers where you stopped.',
  'home.fs.cantHide': 'The checklist could not be changed now.',
  'home.fs.done': 'Done',
  'home.fs.next': 'Next',
  'home.fs.open': 'Open assistant',
  'home.fs.again': 'Open again',
  'home.card.fs.connect-directory.title': 'Connect the directory',
  'home.card.fs.connect-directory.foot': 'Entra ID, Google Workspace, Okta or Keycloak: people, groups and sign-in in one connection.',
  'home.card.fs.create-agent.title': 'Create the agent',
  'home.card.fs.create-agent.foot': 'Signed installer published through Intune, GPO or a link.',
  'home.card.fs.add-collector.title': 'Add a collector',
  'home.card.fs.add-collector.foot': 'Optional: discovers the network and works as a local cache.',
  'home.card.fs.first-alert-rule.title': 'First alert rule',
  'home.card.fs.first-alert-rule.foot': 'Start from a template and see how many assets would trigger today.',
  'home.card.fs.first-dashboard.title': 'First dashboard',
  'home.card.fs.first-dashboard.foot': 'Build the team view by dragging widgets.',
  'home.now.title': 'What you can do now',
  'home.now.invite': 'Invite your team',
  'home.now.inviteDesc': 'By email, choosing the profiles. Nobody needs a password created by hand.',
  'home.now.sso': 'Turn on sign-in with the company account',
  'home.now.ssoDesc': 'OIDC / OAuth 2.0 or SAML 2.0, by assistant, with a test before turning on.',
  'home.now.integrations': 'Connect integrations',
  'home.now.integrationsDesc': 'Directories, messaging, ITSM and more — each connection once, with several uses.',
  'home.now.api': 'Create an integration account',
  'home.now.apiDesc': 'A token for another platform to read data, without OAuth and without a person’s password.',
  'home.now.help': 'Read the manual',
  'home.now.helpDesc': 'Every screen has its help; the “?” button opens the right section.',

  'search.title': 'Global search',
  'search.results': 'Search results',
  'search.none': 'Nothing found. Try a name, an email or the name of a screen.',
  'search.took': 'Answered in {ms} ms',
  'search.group.people': 'People',
  'search.group.screens': 'Screens',
  'search.group.profiles': 'Profiles',
  'search.group.integrations': 'Integrations',
  'search.group.templates': 'Templates',
  'search.group.assets': 'Assets',
  'search.group.apiAccounts': 'Integration accounts',

  'notFound.title': 'Page not found',
  'notFound.text': 'This address does not exist in Hive.',
  'notFound.home': 'Go to Home',
  'denied.title': 'This screen is not available for your profile',

  'helpCenter.title': 'Help center and manual',
  'helpCenter.sub': 'The full manual, with search, in your language. On any screen, the “?” button opens the right section.',
  'helpCenter.search': 'Search the manual',
  'helpCenter.index': 'Manual contents',
  'helpCenter.results.one': '{count} result for “{q}”',
  'helpCenter.results.other': '{count} results for “{q}”',
  "map.zoom": "Zoom",
  "map.zoomIn": "Zoom in (Ctrl + wheel)",
  "map.zoomOut": "Zoom out (Ctrl + wheel)",
  "map.fit": "Fit",
  "map.realSize": "Actual size",
  "map.portsOfSwitch": "Ports of {name}",
  "map.portsOfDevice": "Open ports of {name}",
  "map.openFull": "Open full page",
  "map.closePorts": "Close ports",
  "map.fitPct": "Fit · {n}%",
  "menu.navStyle": "Menu: {name}",
  "menu.navChanged": "Menu changed to {name}",
  "menu.nav.rail": "rail",
  "menu.nav.tree": "tree",
  'home.unavailable': "Not available in this installation.",
  'auto.title': "Managed by Autonomous",
  'auto.text': "This installation is integrated with Autonomous: {screen} is handled there. Nothing was removed from Hive; the screen is hidden for every profile while the integration is on.",
  'auto.feeds': "How this screen's data reaches Autonomous:",
  'auto.feed.bus': "Event bus, category \"{c}\" (sent as it happens)",
  'auto.feed.api': "Autonomous reads it through the Hive API",
  'auto.feed.alertsClose': "Autonomous closes the alert in Hive through the API (the NOC and SOC walls update)",
  'auto.feed.gap': "No event of its own yet: publishing is still to be done",
  'auto.feed.none': "Configuration only: no data to send",
  'pmx.autonomous': "Autonomous",
  'auto.ops.nav': "Operational activities",
  'auto.ops.title': "Operational activities",
  'auto.ops.sub': "What waits for a decision you can take in Hive, most urgent first. Decisions about alerts, incident response, risk acceptance and AI recommendations are made in Autonomous.",
  'pmx.autonomousTip': "Managed by Autonomous in this installation: no profile can turn it on.",
  'pmx.autonomousNote': "Screens marked Autonomous are hidden for every profile while the integration is on. What a profile already had is kept and comes back if the integration is turned off.",
  'ws.ctxInline': 'Filters and views of this screen',
  'cmd.go': 'Go to {screen}',
  'cmd.theme': 'Switch theme (now: {name})',
  'cmd.panel': 'Show or hide the context panel',
  'cmd.assetWord': 'asset',
  'cmd.asset': 'Find asset “{q}”',
  'cmd.assetHint': 'asset <name, IP or user>',
  'home.greet.morning': 'Good morning, {name}',
  'home.greet.afternoon': 'Good afternoon, {name}',
  'home.greet.evening': 'Good evening, {name}',
  'home.greet.sub': 'what needs attention in your environment now',
  'home.kpis': 'Indicators',
  'home.kpi.assets': 'Assets in the inventory',
  'home.attn.title': 'Needs attention now',
  'home.attn.sub': 'predicted first, then the open ones',
  'home.attn.queue': 'See queue',
  'home.attn.open': 'Open',
  'home.tag.pred': 'PREDICTED',
  'home.tag.predIn': 'PREDICTED · {when}',
  'home.tag.crit': 'CRITICAL',
  'home.tag.warn': 'ATTENTION',
  'home.tag.info': 'INFO',
  'home.certs.title': 'Agent certificates expiring',
  'home.certs.where': 'renewed by the agent; check the ones offline',
  'home.agents.title': 'Agents online',
  'home.agents.now': '{online} of {total} online now · {late} late · {offline} without contact for more than 24 h',
  'home.agents.bar': 'Agents: {online} online, {late} late, {offline} offline',
  'home.agents.none': 'No agent installed yet.',
  'home.recent.title': 'Pick up where you left off',
  'home.recent.none': 'The screens you open appear here.',
  'home.status.collectors.one': '{count} collector online',
  'home.status.collectors.other': '{count} collectors online',
  'home.status.agents': '{count} agents online',
  'home.status.what': 'home',
} as const;

type K = keyof typeof en;

const ptBR: Record<K, string> = {
  'app.navLabel': 'Menu principal',
  'nav.home': 'Início',
  'nav.admin': 'Administração',
  'nav.users': 'Usuários e perfis',
  'nav.integrations': 'Central de integrações',
  'nav.audit': 'Trilha de auditoria',
  'nav.settings': 'Configurações da empresa',
  'ws.label': 'Espaços',
  'ws.home': 'Início',
  'ws.assets': 'Ativos',
  'ws.discovery': 'Descoberta',
  'ws.maps': 'Mapas',
  'ws.monitor': 'Monitorar',
  'ws.security': 'Segurança',
  'ws.governance': 'Governança',
  'ws.delivery': 'Entrega',
  'ws.integrations': 'Integrações',
  'ws.admin': 'Admin',
  'ws.help': 'Ajuda',
  'ws.more': 'Mais',
  'ws.collapse': 'Recolher menu',
  'ws.expand': 'Expandir menu',
  'ws.pin': 'Manter o menu aberto',
  'map.fullscreen': 'Tela cheia',
  'map.newTab': 'Abrir em nova aba',
  'map.exportPng': 'Imagem (PNG)',
  'map.exportSvg': 'Imagem (SVG)',
  'map.exportHint': 'Baixa o mapa inteiro como imagem, no tamanho real, com o título e a data',
  'map.exportFailed': 'Não deu para gerar a imagem; tente o SVG.',
  'map.close': 'Fechar tela cheia',
  'nav.helpGroup': 'Ajuda',
  'nav.help': 'Central de ajuda e manual',
  'top.home': '{product} — ir para o Início',
  'top.search': 'Buscar ativo, pessoa, tela ou executar um comando',
  'top.searchLabel': 'Abrir busca global (Ctrl+K)',
  'foot.shortcuts': 'Atalhos: Ctrl + K busca global · Esc fecha diálogos',

  'menu.user': 'Menu do usuário',
  'menu.activeProfile': 'Perfil ativo',
  'menu.switchProfile': 'Trocar o perfil ativo',
  'menu.switchedTo': 'Perfil ativo: {name}. As permissões mudaram na hora.',
  'menu.switchFailed': 'Não foi possível trocar o perfil. Tente de novo.',
  'menu.theme': 'Tema: {name} (trocar)',
  'menu.install': 'Instalar o Hive como app',
  'menu.signOut': 'Sair',
  'menu.signOutTitle': 'Sair do Hive?',
  'menu.signOutText': 'Os dados guardados neste aparelho (rascunhos em preenchimento) são apagados ao sair.',

  'boot.noTenant.title': 'Abra o endereço da sua empresa',
  'boot.noTenant.text': 'Cada empresa tem o próprio endereço, como aurora.localhost:47173. Use o endereço que o administrador enviou.',
  'boot.notFound.title': 'Não há empresa ativa neste endereço',
  'boot.notFound.text': 'Confira o endereço com o administrador. Se a empresa foi suspensa, a entrada volta quando ela for reativada.',
  'boot.error.title': 'O Hive não conseguiu abrir',
  'boot.error.note': 'Se o problema continuar, o administrador pode verificar a situação da plataforma com o provedor de serviços.',

  'signin.title': 'Entrar no {product}',
  'signin.tagline': 'Todo o parque de TI em um só lugar — sem VPN e sem código.',
  'signin.bullet1': 'Inventário de estações, servidores, rede e nuvem',
  'signin.bullet2': 'Alertas avaliados no próprio agente, em segundos',
  'signin.bullet3': 'Tudo por assistentes, com prévia antes de salvar',
  'signin.sideFoot': 'Seus dados ficam na área da sua empresa. Nada aqui é compartilhado com outras empresas.',
  'signin.sso': 'Entrar com a conta da empresa (SSO)',
  'signin.saml': 'Entrar com a conta da empresa (SAML)',
  'signin.local': 'Entrar com sua conta do Hive',
  'signin.ldap': 'Usuário e senha do domínio',
  'signin.ldapNote': 'Contas do domínio: use o e-mail ou usuário@domínio e a senha do domínio; ela é conferida no Active Directory pelo coletor, via LDAPS.',
  'signin.or': 'ou',
  'signin.localHint': 'Perfis privilegiados também confirmam com o código do aplicativo autenticador.',
  'signin.methodsHint': 'Só aparecem os jeitos de entrar que a sua empresa ligou.',
  'signin.noMethods': 'Nenhum método de entrada está ligado nesta empresa. Fale com o administrador.',
  'signin.redirecting': 'Abrindo a página de entrada…',
  'signin.redirectingHint': 'Você volta para a tela em que estava assim que a entrada for confirmada.',
  'signin.unreachable': 'Não foi possível abrir a página de entrada. Confira sua conexão e tente de novo.',
  'signin.callback.what': 'Não foi possível concluir a entrada.',
  'signin.callback.why': 'A página de entrada devolveu um erro, ou o link foi aberto duas vezes.',
  'signin.callback.fix': 'Entre de novo.',
  'signin.pwa.title': 'Instale o Hive como app',
  'signin.pwa.text': 'Abre em janela própria e atualiza sozinho. Sem loja de aplicativos.',
  'signin.pwa.manual': 'Use o menu do navegador: “Instalar app” ou “Adicionar à tela inicial”. Sem loja de aplicativos.',
  'signin.pwa.install': 'Instalar',
  'signin.pwa.later': 'Agora não',
  'signin.pwa.laterToast': 'Tudo bem. Dá para instalar depois pelo menu do usuário.',
  'signin.email': 'E-mail',
  'signin.password': 'Senha',
  'signin.submit': 'Entrar',
  'signin.forgot': 'Esqueceu a senha?',
  'signin.forgotText': 'Digite seu e-mail. Se houver conta, o link para escolher uma senha nova chega em alguns minutos (vale por 1 hora).',
  'signin.forgotSend': 'Enviar link',
  'signin.forgotSent': 'Se o e-mail tiver conta aqui, o link está a caminho. Olhe a caixa de entrada e o spam.',
  'signin.back': 'Voltar',
  'signin.mfa.title': 'Código do autenticador',
  'signin.mfa.text': 'Digite o código de 6 dígitos que aparece no seu aplicativo autenticador.',
  'signin.mfa.code': 'Código',
  'signin.mfa.recoveryHint': 'Perdeu o celular? Digite um dos seus códigos de recuperação no lugar.',
  'signin.verify': 'Confirmar',
  'signin.enroll.title': 'Cadastre o aplicativo autenticador',
  'signin.enroll.text': 'Seu perfil exige um segundo fator. Leia o código com o Google Authenticator, o Microsoft Authenticator ou outro aplicativo TOTP e digite o código que ele mostrar.',
  'signin.enroll.manual': 'Não dá para ler? Digite esta chave no aplicativo:',
  'signin.enroll.qr': 'QR code para cadastrar o aplicativo autenticador',
  'signin.recovery.title': 'Guarde seus códigos de recuperação',
  'signin.recovery.text': 'Cada código entra uma vez se você perder o celular. Guarde num lugar seguro: eles não aparecem de novo.',
  'signin.recovery.copy': 'Copiar códigos',
  'signin.recovery.copied': 'Códigos copiados.',
  'signin.recovery.done': 'Já guardei, continuar',
  'signin.invite.title': 'Crie sua senha',
  'signin.invite.text': 'Boas-vindas a {company}. Escolha a senha de {email}.',
  'signin.reset.title': 'Escolha uma senha nova',
  'signin.reset.text': 'Senha nova para {email}. As outras sessões são encerradas.',
  'signin.newPassword': 'Senha nova',
  'signin.confirmPassword': 'Repita a senha',
  'signin.passwordRules': 'Pelo menos 12 caracteres, sem o seu e-mail. Uma frase curta é fácil de lembrar e difícil de adivinhar.',
  'signin.mismatch': 'As duas senhas estão diferentes.',
  'signin.setPassword': 'Salvar senha e entrar',
  'signin.linkChecking': 'Conferindo o link…',
  'signin.ssoBack': 'Concluindo a entrada com a conta da empresa…',
  'menu.security': 'Segurança da conta',
  'auth.kc.title': 'Keycloak como fonte de usuários',
  'auth.kc.text': 'As contas podem vir de um realm do Keycloak: o Hive traz de hora em hora e confere a senha lá, sem mostrar a tela do Keycloak. O acesso vem dos mapeamentos de grupos abaixo; nada é gravado no Keycloak.',
  'auth.kc.connect': 'Conectar na Central de integrações',
  'auth.kc.sync': 'Trazer agora',
  'auth.kc.done': '{created} conta(s) nova(s) de {read} lida(s).',
  'auth.kc.counts': 'Lidas {read} · novas {created} · desativadas {disabled} · sem grupo mapeado {without}',
  'sec.me.title': 'Segurança da conta',
  'sec.me.sub': 'Sua senha, o aplicativo autenticador e onde você está conectado.',
  'sec.me.totp': 'Aplicativo autenticador',
  'sec.me.on': 'Ligado',
  'sec.me.off': 'Desligado',
  'sec.me.since': 'desde {when}',
  'sec.me.required': 'Seu perfil exige o aplicativo autenticador.',
  'sec.me.codesLeft': 'Restam {n} código(s) de recuperação.',
  'sec.me.turnOn': 'Cadastrar o aplicativo',
  'sec.me.newPhone': 'Trocar de celular',
  'sec.me.newCodes': 'Novos códigos de recuperação',
  'sec.me.turnOff': 'Desligar',
  'sec.me.codePrompt': 'Confirme com o código atual do aplicativo',
  'sec.me.totpOff': 'Autenticador desligado.',
  'sec.me.password': 'Senha',
  'sec.me.pwSince': 'Definida {when}',
  'sec.me.current': 'Senha atual',
  'sec.me.change': 'Trocar senha',
  'sec.me.pwChanged': 'Senha trocada. As outras sessões foram encerradas.',
  'sec.me.pwElsewhere': 'Sua senha é gerenciada pelo diretório da empresa; troque onde você costuma trocar.',
  'sec.me.sessions': 'Onde você está conectado',
  'sec.me.device': 'Navegador',
  'sec.me.started': 'Entrou',
  'sec.me.lastUse': 'Último uso',
  'sec.me.endSession': 'Encerrar sessão',
  'sec.me.endSessionText': 'O navegador daquela sessão pede a senha de novo.',
  'users.resetMfa': 'Zerar autenticador',
  'users.resetMfaTitle': 'Zerar o autenticador de {email}?',
  'users.resetMfaText': 'As sessões da pessoa terminam e, no próximo login, ela cadastra o aplicativo de novo (por exemplo, depois de perder o celular).',
  'users.resetMfaDone': 'Autenticador de {email} zerado.',

  'home.title': 'Início',
  'home.sub': 'O que precisa de atenção hoje. Clique num item para abrir a lista já filtrada.',
  'home.inventory.title': 'Inventário e monitoração',
  'home.inventory.note': 'Preenchidos conforme os agentes enviam inventário.',
  'home.notYet': 'Ainda sem dados',
  'home.card.assetsByType.title': 'Ativos no inventário',
  'home.card.assetsByType.foot': 'Por tipo, vindos dos agentes e diretórios.',
  'home.card.agentCoverage.title': 'Cobertura de agentes',
  'home.card.agentCoverage.foot': 'Computadores conhecidos que enviam inventário.',
  'home.card.openAlerts.title': 'Alertas abertos',
  'home.card.openAlerts.foot': 'Por severidade.',
  'home.card.changes24h.title': 'Mudanças nas últimas 24 h',
  'home.card.changes24h.foot': 'Detectadas pelo agente em segundos.',
  'home.card.agentlessMachines.title': 'Máquinas sem agente',
  'home.card.agentlessMachines.foot': 'Estão no diretório mas ainda não enviam inventário.',
  'home.card.assetsKind.title': '{kind}',
  'home.kind.notebook': 'Notebooks',
  'home.kind.desktop': 'Desktops',
  'home.kind.server': 'Servidores',
  'home.kind.vm': 'Máquinas virtuais',
  'home.kind.printer': 'Impressoras',
  'home.kind.network': 'Equipamentos de rede',
  'home.kind.smartphone': 'Smartphones',
  'home.kind.cloud': 'Recursos de nuvem',
  'home.card.supportRequestsPending.title': 'Pedidos de acesso de suporte',
  'home.card.supportRequestsPending.foot': 'Da equipe do provedor de serviços, aguardando a sua decisão.',
  'home.card.invitesPending.title': 'Convites ainda não aceitos',
  'home.card.invitesPending.foot': 'Pessoas convidadas que ainda não entraram.',
  'home.card.accessRequestsPending.title': 'Pessoas aguardando acesso',
  'home.card.accessRequestsPending.foot': 'Entraram pelo provedor de identidade sem convite.',
  'home.card.rightsizingSavings.title': 'Economia possível por mês ({currency})',
  'home.card.rightsizingSavings.foot': 'Desligue as máquinas ociosas e diminua as superdimensionadas (Otimização e economia).',
  'home.card.rightsizingRecommendations.title': 'Máquinas para redimensionar',
  'home.card.rightsizingRecommendations.foot': 'Ociosas, super ou subdimensionadas pelo uso real (Otimização e economia).',
  'home.card.integrationsWithProblems.title': 'Integrações com problema',
  'home.card.integrationsWithProblems.foot': 'Conexões com erro ou que precisam de atenção.',
  'home.card.apiTokensExpiring.title': 'Tokens de integração vencendo',
  'home.card.apiTokensExpiring.foot': 'Vencem nos próximos 15 dias.',
  'home.attention.title': 'O que precisa de atenção',
  'home.attention.none': 'Nada para o seu perfil agora.',
  'home.fs.title': 'Primeiros passos',
  'home.fs.progress': '{done} de {total} concluídos',
  'home.fs.goal': 'Meta: primeiro inventário em até 30 min',
  'home.fs.hide': 'Esconder checklist',
  'home.fs.show': 'Mostrar primeiros passos',
  'home.fs.hiddenToast': 'Checklist escondido. Ele lembra onde você parou.',
  'home.fs.cantHide': 'Não foi possível mudar o checklist agora.',
  'home.fs.done': 'Concluído',
  'home.fs.next': 'Próximo',
  'home.fs.open': 'Abrir assistente',
  'home.fs.again': 'Abrir de novo',
  'home.card.fs.connect-directory.title': 'Conectar o diretório',
  'home.card.fs.connect-directory.foot': 'Entra ID, Google Workspace, Okta ou Keycloak: pessoas, grupos e entrada numa só conexão.',
  'home.card.fs.create-agent.title': 'Criar o agente',
  'home.card.fs.create-agent.foot': 'Instalador assinado publicado pelo Intune, GPO ou link.',
  'home.card.fs.add-collector.title': 'Adicionar coletor',
  'home.card.fs.add-collector.foot': 'Opcional: descobre a rede e serve de cache local.',
  'home.card.fs.first-alert-rule.title': 'Primeira regra de alerta',
  'home.card.fs.first-alert-rule.foot': 'Parta de um modelo e veja quantos ativos disparariam hoje.',
  'home.card.fs.first-dashboard.title': 'Primeiro painel',
  'home.card.fs.first-dashboard.foot': 'Monte a visão da equipe arrastando widgets.',
  'home.now.title': 'O que você já pode fazer',
  'home.now.invite': 'Convidar a equipe',
  'home.now.inviteDesc': 'Por e-mail, escolhendo os perfis. Ninguém precisa de senha criada à mão.',
  'home.now.sso': 'Ligar a entrada com a conta da empresa',
  'home.now.ssoDesc': 'OIDC / OAuth 2.0 ou SAML 2.0, por assistente, com teste antes de ligar.',
  'home.now.integrations': 'Conectar integrações',
  'home.now.integrationsDesc': 'Diretórios, mensageria, ITSM e mais — cada conexão uma vez, com vários usos.',
  'home.now.api': 'Criar uma conta de integração',
  'home.now.apiDesc': 'Um token para outra plataforma ler dados, sem OAuth e sem a senha de uma pessoa.',
  'home.now.help': 'Ler o manual',
  'home.now.helpDesc': 'Toda tela tem a sua ajuda; o botão “?” abre a seção certa.',

  'search.title': 'Busca global',
  'search.results': 'Resultados da busca',
  'search.none': 'Nada encontrado. Tente um nome, um e-mail ou o nome de uma tela.',
  'search.took': 'Respondido em {ms} ms',
  'search.group.people': 'Pessoas',
  'search.group.screens': 'Telas',
  'search.group.profiles': 'Perfis',
  'search.group.integrations': 'Integrações',
  'search.group.templates': 'Modelos',
  'search.group.assets': 'Ativos',
  'search.group.apiAccounts': 'Contas de integração',

  'notFound.title': 'Página não encontrada',
  'notFound.text': 'Este endereço não existe no Hive.',
  'notFound.home': 'Ir para o Início',
  'denied.title': 'Esta tela não está disponível para o seu perfil',

  'helpCenter.title': 'Central de ajuda e manual',
  'helpCenter.sub': 'O manual completo, com busca, no seu idioma. Em qualquer tela, o botão “?” abre a seção certa.',
  'helpCenter.search': 'Procurar no manual',
  'helpCenter.index': 'Índice do manual',
  'helpCenter.results.one': '{count} resultado para “{q}”',
  'helpCenter.results.other': '{count} resultados para “{q}”',
  "map.zoom": "Zoom",
  "map.zoomIn": "Aproximar (Ctrl + roda do mouse)",
  "map.zoomOut": "Afastar (Ctrl + roda do mouse)",
  "map.fit": "Ajustar",
  "map.realSize": "Tamanho real",
  "map.portsOfSwitch": "Portas de {name}",
  "map.portsOfDevice": "Portas abertas de {name}",
  "map.openFull": "Abrir a página inteira",
  "map.closePorts": "Fechar portas",
  "map.fitPct": "Ajustado · {n}%",
  "menu.navStyle": "Menu: {name}",
  "menu.navChanged": "Menu trocado para {name}",
  "menu.nav.rail": "trilhos",
  "menu.nav.tree": "árvore",
  'home.unavailable': "Não disponível nesta instalação.",
  'auto.title': "Gerida pelo Autonomous",
  'auto.text': "Esta instalação está integrada ao Autonomous: {screen} é tratada lá. Nada foi removido do Hive; a tela fica oculta para todos os perfis enquanto a integração estiver ligada.",
  'auto.feeds': "Como os dados desta tela chegam ao Autonomous:",
  'auto.feed.bus': "Barramento de eventos, categoria \"{c}\" (enviado na hora)",
  'auto.feed.api': "O Autonomous lê pela API do Hive",
  'auto.feed.alertsClose': "O Autonomous fecha o alerta no Hive pela API (os murais NOC e SOC se atualizam)",
  'auto.feed.gap': "Ainda sem evento próprio: falta publicar",
  'auto.feed.none': "Só configuração: não há dados a enviar",
  'pmx.autonomous': "Autonomous",
  'auto.ops.nav': "Atividades Operacionais",
  'auto.ops.title': "Atividades Operacionais",
  'auto.ops.sub': "O que espera uma decisão que você pode tomar no Hive, do mais urgente ao menos. As decisões de alertas, resposta a incidente, aceite de risco e recomendações da IA são tomadas no Autonomous.",
  'pmx.autonomousTip': "Gerida pelo Autonomous nesta instalação: nenhum perfil pode ligá-la.",
  'pmx.autonomousNote': "As telas marcadas Autonomous ficam ocultas para todos os perfis enquanto a integração estiver ligada. O que o perfil já tinha fica guardado e volta se a integração for desligada.",
  'ws.ctxInline': 'Filtros e visões desta tela',
  'cmd.go': 'Ir para {screen}',
  'cmd.theme': 'Trocar o tema (agora: {name})',
  'cmd.panel': 'Mostrar ou recolher o painel de contexto',
  'cmd.assetWord': 'ativo',
  'cmd.asset': 'Procurar o ativo “{q}”',
  'cmd.assetHint': 'ativo <nome, IP ou usuário>',
  'home.greet.morning': 'Bom dia, {name}',
  'home.greet.afternoon': 'Boa tarde, {name}',
  'home.greet.evening': 'Boa noite, {name}',
  'home.greet.sub': 'o que pede atenção agora no parque',
  'home.kpis': 'Indicadores',
  'home.kpi.assets': 'Ativos no inventário',
  'home.attn.title': 'Atenção agora',
  'home.attn.sub': 'previstas primeiro, depois as abertas',
  'home.attn.queue': 'Ver fila',
  'home.attn.open': 'Abrir',
  'home.tag.pred': 'PREVISTA',
  'home.tag.predIn': 'PREVISTA · {when}',
  'home.tag.crit': 'CRÍTICO',
  'home.tag.warn': 'ATENÇÃO',
  'home.tag.info': 'INFO',
  'home.certs.title': 'Certificados de agentes vencendo',
  'home.certs.where': 'o agente renova; confira os que estão desligados',
  'home.agents.title': 'Agentes online',
  'home.agents.now': '{online} de {total} online agora · {late} atrasados · {offline} sem contato há mais de 24 h',
  'home.agents.bar': 'Agentes: {online} online, {late} atrasados, {offline} desligados',
  'home.agents.none': 'Nenhum agente instalado ainda.',
  'home.recent.title': 'Continuar de onde parou',
  'home.recent.none': 'As telas que você abrir aparecem aqui.',
  'home.status.collectors.one': '{count} coletor online',
  'home.status.collectors.other': '{count} coletores online',
  'home.status.agents': '{count} agentes online',
  'home.status.what': 'início',
};

const es: Record<K, string> = {
  'app.navLabel': 'Menú principal',
  'nav.home': 'Inicio',
  'nav.admin': 'Administración',
  'nav.users': 'Usuarios y perfiles',
  'nav.integrations': 'Centro de integraciones',
  'nav.audit': 'Registro de auditoría',
  'nav.settings': 'Configuración de la empresa',
  'ws.label': 'Espacios',
  'ws.home': 'Inicio',
  'ws.assets': 'Activos',
  'ws.discovery': 'Descubrimiento',
  'ws.maps': 'Mapas',
  'ws.monitor': 'Monitorear',
  'ws.security': 'Seguridad',
  'ws.governance': 'Gobernanza',
  'ws.delivery': 'Entrega',
  'ws.integrations': 'Integraciones',
  'ws.admin': 'Admin',
  'ws.help': 'Ayuda',
  'ws.more': 'Más',
  'ws.collapse': 'Contraer menú',
  'ws.expand': 'Expandir menú',
  'ws.pin': 'Mantener el menú abierto',
  'map.fullscreen': 'Pantalla completa',
  'map.newTab': 'Abrir en una pestaña nueva',
  'map.exportPng': 'Imagen (PNG)',
  'map.exportSvg': 'Imagen (SVG)',
  'map.exportHint': 'Descarga el mapa completo como imagen, a tamaño real, con el título y la fecha',
  'map.exportFailed': 'No se pudo generar la imagen; pruebe el SVG.',
  'map.close': 'Cerrar pantalla completa',
  'nav.helpGroup': 'Ayuda',
  'nav.help': 'Centro de ayuda y manual',
  'top.home': '{product} — ir al Inicio',
  'top.search': 'Buscar activo, persona, pantalla o ejecutar un comando',
  'top.searchLabel': 'Abrir búsqueda global (Ctrl+K)',
  'foot.shortcuts': 'Atajos: Ctrl + K búsqueda global · Esc cierra diálogos',

  'menu.user': 'Menú del usuario',
  'menu.activeProfile': 'Perfil activo',
  'menu.switchProfile': 'Cambiar el perfil activo',
  'menu.switchedTo': 'Perfil activo: {name}. Los permisos cambiaron de inmediato.',
  'menu.switchFailed': 'No fue posible cambiar el perfil. Inténtelo de nuevo.',
  'menu.theme': 'Tema: {name} (cambiar)',
  'menu.install': 'Instalar Hive como app',
  'menu.signOut': 'Cerrar sesión',
  'menu.signOutTitle': '¿Cerrar sesión en Hive?',
  'menu.signOutText': 'Los datos guardados en este dispositivo (borradores en curso) se borran al cerrar sesión.',

  'boot.noTenant.title': 'Abra la dirección de su empresa',
  'boot.noTenant.text': 'Cada empresa tiene su propia dirección, como aurora.localhost:47173. Use la dirección que le envió el administrador.',
  'boot.notFound.title': 'No hay una empresa activa en esta dirección',
  'boot.notFound.text': 'Verifique la dirección con el administrador. Si la empresa fue suspendida, el inicio de sesión vuelve cuando se reactive.',
  'boot.error.title': 'Hive no pudo abrirse',
  'boot.error.note': 'Si el problema continúa, el administrador puede verificar el estado de la plataforma con el proveedor de servicios.',

  'signin.title': 'Iniciar sesión en {product}',
  'signin.tagline': 'Toda la TI en un solo lugar — sin VPN y sin código.',
  'signin.bullet1': 'Inventario de estaciones, servidores, red y nube',
  'signin.bullet2': 'Alertas evaluadas en el propio agente, en segundos',
  'signin.bullet3': 'Todo con asistentes, con vista previa antes de guardar',
  'signin.sideFoot': 'Sus datos quedan en el área de su empresa. Nada aquí se comparte con otras empresas.',
  'signin.sso': 'Iniciar sesión con la cuenta de la empresa (SSO)',
  'signin.saml': 'Iniciar sesión con la cuenta de la empresa (SAML)',
  'signin.local': 'Iniciar sesión con su cuenta de Hive',
  'signin.ldap': 'Usuario y contraseña del dominio',
  'signin.ldapNote': 'Cuentas del dominio: use su correo o usuario@dominio y la contraseña del dominio; se verifica en Active Directory por el colector, vía LDAPS.',
  'signin.or': 'o',
  'signin.localHint': 'Los perfiles privilegiados también confirman con el código de la aplicación autenticadora.',
  'signin.methodsHint': 'Solo aparecen las formas de iniciar sesión que su empresa activó.',
  'signin.noMethods': 'No hay ningún método de inicio de sesión activo en esta empresa. Hable con el administrador.',
  'signin.redirecting': 'Abriendo la página de inicio de sesión…',
  'signin.redirectingHint': 'Vuelve a la pantalla en la que estaba en cuanto se confirme el inicio de sesión.',
  'signin.unreachable': 'No fue posible abrir la página de inicio de sesión. Revise su conexión e inténtelo de nuevo.',
  'signin.callback.what': 'No fue posible completar el inicio de sesión.',
  'signin.callback.why': 'La página de inicio de sesión devolvió un error, o el enlace se abrió dos veces.',
  'signin.callback.fix': 'Inicie sesión de nuevo.',
  'signin.pwa.title': 'Instale Hive como app',
  'signin.pwa.text': 'Se abre en su propia ventana y se actualiza solo. Sin tienda de aplicaciones.',
  'signin.pwa.manual': 'Use el menú del navegador: “Instalar app” o “Agregar a la pantalla de inicio”. Sin tienda de aplicaciones.',
  'signin.pwa.install': 'Instalar',
  'signin.pwa.later': 'Ahora no',
  'signin.pwa.laterToast': 'Está bien. Puede instalarlo después desde el menú del usuario.',
  'signin.email': 'Correo electrónico',
  'signin.password': 'Contraseña',
  'signin.submit': 'Entrar',
  'signin.forgot': '¿Olvidó su contraseña?',
  'signin.forgotText': 'Escriba su correo. Si hay una cuenta, el enlace para elegir una nueva contraseña llega en unos minutos (válido por 1 hora).',
  'signin.forgotSend': 'Enviar enlace',
  'signin.forgotSent': 'Si el correo tiene cuenta aquí, el enlace está en camino. Revise la bandeja de entrada y el spam.',
  'signin.back': 'Volver',
  'signin.mfa.title': 'Código del autenticador',
  'signin.mfa.text': 'Escriba el código de 6 dígitos que aparece en su aplicación autenticadora.',
  'signin.mfa.code': 'Código',
  'signin.mfa.recoveryHint': '¿Perdió el teléfono? Escriba uno de sus códigos de recuperación.',
  'signin.verify': 'Confirmar',
  'signin.enroll.title': 'Registre la aplicación autenticadora',
  'signin.enroll.text': 'Su perfil exige un segundo factor. Escanee el código con Google Authenticator, Microsoft Authenticator u otra aplicación TOTP y escriba el código que muestre.',
  'signin.enroll.manual': '¿No puede escanear? Escriba esta clave en la aplicación:',
  'signin.enroll.qr': 'Código QR para registrar la aplicación autenticadora',
  'signin.recovery.title': 'Guarde sus códigos de recuperación',
  'signin.recovery.text': 'Cada código entra una vez si pierde el teléfono. Guárdelos en un lugar seguro: no se vuelven a mostrar.',
  'signin.recovery.copy': 'Copiar códigos',
  'signin.recovery.copied': 'Códigos copiados.',
  'signin.recovery.done': 'Ya los guardé, continuar',
  'signin.invite.title': 'Cree su contraseña',
  'signin.invite.text': 'Bienvenido a {company}. Elija la contraseña de {email}.',
  'signin.reset.title': 'Elija una nueva contraseña',
  'signin.reset.text': 'Nueva contraseña para {email}. Sus otras sesiones se cierran.',
  'signin.newPassword': 'Nueva contraseña',
  'signin.confirmPassword': 'Repita la contraseña',
  'signin.passwordRules': 'Al menos 12 caracteres, sin su correo. Una frase corta es fácil de recordar y difícil de adivinar.',
  'signin.mismatch': 'Las dos contraseñas son diferentes.',
  'signin.setPassword': 'Guardar contraseña y entrar',
  'signin.linkChecking': 'Verificando el enlace…',
  'signin.ssoBack': 'Terminando la entrada con la cuenta de la empresa…',
  'menu.security': 'Seguridad de la cuenta',
  'auth.kc.title': 'Keycloak como fuente de usuarios',
  'auth.kc.text': 'Las cuentas pueden venir de un realm de Keycloak: Hive las trae cada hora y verifica la contraseña allí, sin mostrar la pantalla de Keycloak. El acceso viene de las asignaciones de grupos de abajo; nada se escribe en Keycloak.',
  'auth.kc.connect': 'Conectar en el Centro de integraciones',
  'auth.kc.sync': 'Traer ahora',
  'auth.kc.done': '{created} cuenta(s) nueva(s) de {read} leída(s).',
  'auth.kc.counts': 'Leídas {read} · nuevas {created} · desactivadas {disabled} · sin grupo asignado {without}',
  'sec.me.title': 'Seguridad de la cuenta',
  'sec.me.sub': 'Su contraseña, la aplicación autenticadora y dónde tiene sesión iniciada.',
  'sec.me.totp': 'Aplicación autenticadora',
  'sec.me.on': 'Activada',
  'sec.me.off': 'Desactivada',
  'sec.me.since': 'desde {when}',
  'sec.me.required': 'Su perfil exige la aplicación autenticadora.',
  'sec.me.codesLeft': 'Quedan {n} código(s) de recuperación.',
  'sec.me.turnOn': 'Registrar la aplicación',
  'sec.me.newPhone': 'Cambiar de teléfono',
  'sec.me.newCodes': 'Nuevos códigos de recuperación',
  'sec.me.turnOff': 'Desactivar',
  'sec.me.codePrompt': 'Confirme con el código actual de la aplicación',
  'sec.me.totpOff': 'Autenticador desactivado.',
  'sec.me.password': 'Contraseña',
  'sec.me.pwSince': 'Definida {when}',
  'sec.me.current': 'Contraseña actual',
  'sec.me.change': 'Cambiar contraseña',
  'sec.me.pwChanged': 'Contraseña cambiada. Sus otras sesiones se cerraron.',
  'sec.me.pwElsewhere': 'Su contraseña la gestiona el directorio de la empresa; cámbiela donde suele hacerlo.',
  'sec.me.sessions': 'Dónde tiene sesión iniciada',
  'sec.me.device': 'Navegador',
  'sec.me.started': 'Entró',
  'sec.me.lastUse': 'Último uso',
  'sec.me.endSession': 'Cerrar sesión',
  'sec.me.endSessionText': 'El navegador de esa sesión pide la contraseña de nuevo.',
  'users.resetMfa': 'Restablecer autenticador',
  'users.resetMfaTitle': '¿Restablecer el autenticador de {email}?',
  'users.resetMfaText': 'Sus sesiones terminan y, en el próximo inicio de sesión, registra la aplicación de nuevo (por ejemplo, tras perder el teléfono).',
  'users.resetMfaDone': 'Autenticador de {email} restablecido.',

  'home.title': 'Inicio',
  'home.sub': 'Lo que necesita atención hoy. Haga clic en un elemento para abrir la lista ya filtrada.',
  'home.inventory.title': 'Inventario y monitoreo',
  'home.inventory.note': 'Se completan a medida que los agentes envían inventario.',
  'home.notYet': 'Todavía sin datos',
  'home.card.assetsByType.title': 'Activos en el inventario',
  'home.card.assetsByType.foot': 'Por tipo, de agentes y directorios.',
  'home.card.agentCoverage.title': 'Cobertura de agentes',
  'home.card.agentCoverage.foot': 'Equipos conocidos que envían inventario.',
  'home.card.openAlerts.title': 'Alertas abiertas',
  'home.card.openAlerts.foot': 'Por severidad.',
  'home.card.changes24h.title': 'Cambios en las últimas 24 h',
  'home.card.changes24h.foot': 'Detectados por el agente en segundos.',
  'home.card.agentlessMachines.title': 'Equipos sin agente',
  'home.card.agentlessMachines.foot': 'Están en el directorio pero todavía no envían inventario.',
  'home.card.assetsKind.title': '{kind}',
  'home.kind.notebook': 'Portátiles',
  'home.kind.desktop': 'Equipos de escritorio',
  'home.kind.server': 'Servidores',
  'home.kind.vm': 'Máquinas virtuales',
  'home.kind.printer': 'Impresoras',
  'home.kind.network': 'Equipos de red',
  'home.kind.smartphone': 'Smartphones',
  'home.kind.cloud': 'Recursos de nube',
  'home.card.supportRequestsPending.title': 'Solicitudes de acceso de soporte',
  'home.card.supportRequestsPending.foot': 'Del equipo del proveedor de servicios, esperando su decisión.',
  'home.card.invitesPending.title': 'Invitaciones todavía no aceptadas',
  'home.card.invitesPending.foot': 'Personas invitadas que todavía no iniciaron sesión.',
  'home.card.accessRequestsPending.title': 'Personas esperando acceso',
  'home.card.accessRequestsPending.foot': 'Iniciaron sesión por el proveedor de identidad sin invitación.',
  'home.card.rightsizingSavings.title': 'Ahorro posible por mes ({currency})',
  'home.card.rightsizingSavings.foot': 'Apague las máquinas ociosas y reduzca las sobredimensionadas (Optimización y ahorro).',
  'home.card.rightsizingRecommendations.title': 'Máquinas para redimensionar',
  'home.card.rightsizingRecommendations.foot': 'Ociosas, sobre o subdimensionadas por su uso real (Optimización y ahorro).',
  'home.card.integrationsWithProblems.title': 'Integraciones con problemas',
  'home.card.integrationsWithProblems.foot': 'Conexiones con error o que necesitan atención.',
  'home.card.apiTokensExpiring.title': 'Tokens de integración por vencer',
  'home.card.apiTokensExpiring.foot': 'Vencen en los próximos 15 días.',
  'home.attention.title': 'Lo que necesita atención',
  'home.attention.none': 'Nada para su perfil ahora.',
  'home.fs.title': 'Primeros pasos',
  'home.fs.progress': '{done} de {total} completados',
  'home.fs.goal': 'Meta: primer inventario en hasta 30 min',
  'home.fs.hide': 'Ocultar lista',
  'home.fs.show': 'Mostrar primeros pasos',
  'home.fs.hiddenToast': 'Lista oculta. Recuerda dónde se quedó.',
  'home.fs.cantHide': 'No fue posible cambiar la lista ahora.',
  'home.fs.done': 'Completado',
  'home.fs.next': 'Siguiente',
  'home.fs.open': 'Abrir asistente',
  'home.fs.again': 'Abrir de nuevo',
  'home.card.fs.connect-directory.title': 'Conectar el directorio',
  'home.card.fs.connect-directory.foot': 'Entra ID, Google Workspace, Okta o Keycloak: personas, grupos e inicio de sesión en una sola conexión.',
  'home.card.fs.create-agent.title': 'Crear el agente',
  'home.card.fs.create-agent.foot': 'Instalador firmado publicado por Intune, GPO o enlace.',
  'home.card.fs.add-collector.title': 'Agregar un colector',
  'home.card.fs.add-collector.foot': 'Opcional: descubre la red y sirve de caché local.',
  'home.card.fs.first-alert-rule.title': 'Primera regla de alerta',
  'home.card.fs.first-alert-rule.foot': 'Parta de una plantilla y vea cuántos activos se dispararían hoy.',
  'home.card.fs.first-dashboard.title': 'Primer panel',
  'home.card.fs.first-dashboard.foot': 'Arme la vista del equipo arrastrando widgets.',
  'home.now.title': 'Lo que ya puede hacer',
  'home.now.invite': 'Invitar al equipo',
  'home.now.inviteDesc': 'Por correo, eligiendo los perfiles. Nadie necesita una contraseña creada a mano.',
  'home.now.sso': 'Activar el inicio de sesión con la cuenta de la empresa',
  'home.now.ssoDesc': 'OIDC / OAuth 2.0 o SAML 2.0, con asistente y prueba antes de activar.',
  'home.now.integrations': 'Conectar integraciones',
  'home.now.integrationsDesc': 'Directorios, mensajería, ITSM y más — cada conexión una vez, con varios usos.',
  'home.now.api': 'Crear una cuenta de integración',
  'home.now.apiDesc': 'Un token para que otra plataforma lea datos, sin OAuth y sin la contraseña de una persona.',
  'home.now.help': 'Leer el manual',
  'home.now.helpDesc': 'Cada pantalla tiene su ayuda; el botón “?” abre la sección correcta.',

  'search.title': 'Búsqueda global',
  'search.results': 'Resultados de la búsqueda',
  'search.none': 'No se encontró nada. Pruebe un nombre, un correo o el nombre de una pantalla.',
  'search.took': 'Respondido en {ms} ms',
  'search.group.people': 'Personas',
  'search.group.screens': 'Pantallas',
  'search.group.profiles': 'Perfiles',
  'search.group.integrations': 'Integraciones',
  'search.group.templates': 'Plantillas',
  'search.group.assets': 'Activos',
  'search.group.apiAccounts': 'Cuentas de integración',

  'notFound.title': 'Página no encontrada',
  'notFound.text': 'Esta dirección no existe en Hive.',
  'notFound.home': 'Ir al Inicio',
  'denied.title': 'Esta pantalla no está disponible para su perfil',

  'helpCenter.title': 'Centro de ayuda y manual',
  'helpCenter.sub': 'El manual completo, con búsqueda, en su idioma. En cualquier pantalla, el botón “?” abre la sección correcta.',
  'helpCenter.search': 'Buscar en el manual',
  'helpCenter.index': 'Índice del manual',
  'helpCenter.results.one': '{count} resultado para “{q}”',
  'helpCenter.results.other': '{count} resultados para “{q}”',
  "map.zoom": "Zoom",
  "map.zoomIn": "Acercar (Ctrl + rueda)",
  "map.zoomOut": "Alejar (Ctrl + rueda)",
  "map.fit": "Ajustar",
  "map.realSize": "Tamaño real",
  "map.portsOfSwitch": "Puertos de {name}",
  "map.portsOfDevice": "Puertos abiertos de {name}",
  "map.openFull": "Abrir la página completa",
  "map.closePorts": "Cerrar puertos",
  "map.fitPct": "Ajustado · {n}%",
  "menu.navStyle": "Menú: {name}",
  "menu.navChanged": "Menú cambiado a {name}",
  "menu.nav.rail": "rieles",
  "menu.nav.tree": "árbol",
  'home.unavailable': "No disponible en esta instalación.",
  'auto.title': "Gestionada por Autonomous",
  'auto.text': "Esta instalación está integrada con Autonomous: {screen} se atiende allí. Nada se quitó de Hive; la pantalla queda oculta para todos los perfiles mientras la integración esté activa.",
  'auto.feeds': "Cómo llegan a Autonomous los datos de esta pantalla:",
  'auto.feed.bus': "Bus de eventos, categoría \"{c}\" (enviado al momento)",
  'auto.feed.api': "Autonomous los lee por la API de Hive",
  'auto.feed.alertsClose': "Autonomous cierra la alerta en Hive por la API (los murales NOC y SOC se actualizan)",
  'auto.feed.gap': "Aún sin evento propio: falta publicarlo",
  'auto.feed.none': "Solo configuración: no hay datos que enviar",
  'pmx.autonomous': "Autonomous",
  'auto.ops.nav': "Actividades Operacionales",
  'auto.ops.title': "Actividades Operacionales",
  'auto.ops.sub': "Lo que espera una decisión que usted puede tomar en Hive, de lo más urgente a lo menos. Las decisiones de alertas, respuesta a incidentes, aceptación de riesgo y recomendaciones de la IA se toman en Autonomous.",
  'pmx.autonomousTip': "Gestionada por Autonomous en esta instalación: ningún perfil puede activarla.",
  'pmx.autonomousNote': "Las pantallas marcadas Autonomous quedan ocultas para todos los perfiles mientras la integración esté activa. Lo que el perfil ya tenía se guarda y vuelve si se desactiva la integración.",
  'ws.ctxInline': 'Filtros y vistas de esta pantalla',
  'cmd.go': 'Ir a {screen}',
  'cmd.theme': 'Cambiar el tema (ahora: {name})',
  'cmd.panel': 'Mostrar u ocultar el panel de contexto',
  'cmd.assetWord': 'activo',
  'cmd.asset': 'Buscar el activo “{q}”',
  'cmd.assetHint': 'activo <nombre, IP o usuario>',
  'home.greet.morning': 'Buenos días, {name}',
  'home.greet.afternoon': 'Buenas tardes, {name}',
  'home.greet.evening': 'Buenas noches, {name}',
  'home.greet.sub': 'lo que requiere atención ahora en su entorno',
  'home.kpis': 'Indicadores',
  'home.kpi.assets': 'Activos en el inventario',
  'home.attn.title': 'Atención ahora',
  'home.attn.sub': 'previstas primero, luego las abiertas',
  'home.attn.queue': 'Ver cola',
  'home.attn.open': 'Abrir',
  'home.tag.pred': 'PREVISTA',
  'home.tag.predIn': 'PREVISTA · {when}',
  'home.tag.crit': 'CRÍTICO',
  'home.tag.warn': 'ATENCIÓN',
  'home.tag.info': 'INFO',
  'home.certs.title': 'Certificados de agentes por vencer',
  'home.certs.where': 'el agente los renueva; revise los que están apagados',
  'home.agents.title': 'Agentes en línea',
  'home.agents.now': '{online} de {total} en línea ahora · {late} con retraso · {offline} sin contacto hace más de 24 h',
  'home.agents.bar': 'Agentes: {online} en línea, {late} con retraso, {offline} apagados',
  'home.agents.none': 'Ningún agente instalado todavía.',
  'home.recent.title': 'Continuar donde lo dejó',
  'home.recent.none': 'Las pantallas que abra aparecen aquí.',
  'home.status.collectors.one': '{count} colector en línea',
  'home.status.collectors.other': '{count} colectores en línea',
  'home.status.agents': '{count} agentes en línea',
  'home.status.what': 'inicio',
};

export const shellMessages = { en, 'pt-BR': ptBR, es } as const;
